import { cn } from '../lib/cn';

const SIZES = {
  xs: 'size-6 text-sm ring-2',
  sm: 'size-8 text-base ring-2',
  md: 'size-11 text-2xl ring-[3px]',
  lg: 'size-16 text-4xl ring-4',
  xl: 'size-24 text-6xl ring-4',
} as const;

export function Avatar({
  emoji,
  color,
  size = 'md',
  dimmed = false,
  className,
}: {
  emoji: string;
  color?: string;
  size?: keyof typeof SIZES;
  dimmed?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-grid shrink-0 place-items-center rounded-full bg-ink-800 leading-none select-none',
        SIZES[size],
        dimmed && 'opacity-40 grayscale',
        className,
      )}
      style={{ '--tw-ring-color': color ?? 'var(--color-ink-600)' } as React.CSSProperties}
    >
      <span className="translate-y-[0.04em]">{emoji}</span>
    </span>
  );
}
